import { render, staticRenderFns } from "./TableBank.vue?vue&type=template&id=845ecd24"
import script from "./TableBank.vue?vue&type=script&lang=js"
export * from "./TableBank.vue?vue&type=script&lang=js"
import style0 from "./TableBank.vue?vue&type=style&index=0&id=845ecd24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports